/*
 * Lemonade Training Oy, copy rights, all right reserved.
 * Where My training lives for this person: members' Home, staff's own page
 * (the dashboard home sends staff to Today).
 */
import { todayRoleFor } from "../lib/today";
import { useUserAccess } from "./useUserAccess";

export function useTrainingHome(): string {
  const access = useUserAccess();
  return todayRoleFor(access) !== null ? "/dashboard/training" : "/dashboard/";
}
